import AppLayout from "../components/layout/AppLayout";
import SmartImageUpload from "../components/upload/SmartImageUpload";

export default function Upload() {
  return (
    <AppLayout>
      <SmartImageUpload />
    </AppLayout>
  );
}
